import React from "react";
import { Link } from "react-router-dom";
import { Star, Quote, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const clients = [
  { name: "Cabinet Delacroix Avocats", sector: "Juridique" },
  { name: "Auberge Le Marronnier", sector: "Hôtellerie" },
  { name: "Studios Prisma Média", sector: "Média" },
  { name: "Groupe Novacom", sector: "Communication" },
  { name: "Résidence Les Cèdres", sector: "Copropriété" },
  { name: "Concept Store Nova", sector: "Retail" },
  { name: "Clinique Vétérinaire des Champs", sector: "Santé animale" },
  { name: "Espace Coworking Meridian", sector: "Coworking" },
  { name: "Groupe Immobilier Garance", sector: "Immobilier" },
  { name: "Boulangerie Artisanale Paul&Fils", sector: "Alimentaire" },
  { name: "Cabinet Dentaire Sourire+", sector: "Santé" },
  { name: "Résidence Sénior Belle-Vue", sector: "Résidence services" },
];

const testimonials = [
  {
    quote:
      "Nous travaillons avec GIGA CLEAN depuis 3 ans. Ponctualité irréprochable et personnel de confiance. Nos bureaux n'ont jamais été aussi propres.",
    author: "Marie L.",
    role: "Office Manager, Cabinet Delacroix",
  },
  {
    quote:
      "Après une remise en état complète sur un chantier compliqué, l'équipe a livré un travail impeccable dans les délais. Je recommande sans hésiter.",
    author: "Julien D.",
    role: "Directeur travaux, Groupe Immobilier Garance",
  },
  {
    quote:
      "Une relation humaine que je n'avais jamais eue avec un prestataire de nettoyage. M. Kamagate est disponible et réactif.",
    author: "Sophie R.",
    role: "Gérante, Concept Store Nova",
  },
];

export default function References() {
  return (
    <div className="bg-white">
      <section className="pt-20 md:pt-28 pb-14 bg-[#f0f7ff]">
        <div className="mx-auto max-w-4xl px-6 md:px-10 text-center">
          <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#2196F3] mb-4">Ils nous font confiance</div>
          <h1 className="font-display text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
            150+ entreprises nous confient l'entretien de leurs locaux.
          </h1>
        </div>
      </section>

      <section className="py-20">
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {clients.map((c, i) => (
              <div
                key={i}
                data-testid={`client-card-${i}`}
                className="group bg-slate-50 border border-slate-100 rounded-2xl p-6 hover:bg-[#2196F3] hover:border-[#2196F3]"
                style={{ transitionProperty: "background-color, border-color", transitionDuration: "300ms" }}
              >
                <div className="text-xs uppercase tracking-widest text-[#2196F3] group-hover:text-[#64B5F6] font-semibold" style={{ transitionProperty: "color", transitionDuration: "300ms" }}>
                  {c.sector}
                </div>
                <div className="mt-3 font-display font-bold text-lg text-slate-900 group-hover:text-white leading-tight" style={{ transitionProperty: "color", transitionDuration: "300ms" }}>
                  {c.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 md:py-24 bg-slate-50">
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <h2 className="font-display text-3xl md:text-5xl font-extrabold text-slate-900 max-w-2xl mb-12">
            Ce que disent nos clients.
          </h2>
          <div className="grid gap-6 md:grid-cols-3">
            {testimonials.map((t, i) => (
              <div key={i} className="bg-white rounded-2xl border border-slate-100 p-8">
                <Quote className="h-8 w-8 text-[#2196F3]/40" />
                <div className="mt-3 flex gap-1">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} className="h-4 w-4 fill-[#F59E0B] text-[#F59E0B]" />
                  ))}
                </div>
                <p className="mt-5 text-slate-700 leading-relaxed">« {t.quote} »</p>
                <div className="mt-6 pt-5 border-t border-slate-100">
                  <div className="font-display font-semibold text-slate-900">{t.author}</div>
                  <div className="text-sm text-slate-500">{t.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28">
        <div className="mx-auto max-w-6xl px-6 md:px-10">
          <div className="relative overflow-hidden rounded-3xl bg-[#1976D2] p-10 md:p-16 grain">
            <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
              <div>
                <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white leading-tight">
                  Rejoignez nos clients satisfaits.
                </h2>
                <p className="text-white/80 mt-4 max-w-xl">Demandez votre devis personnalisé aujourd'hui.</p>
              </div>
              <Link to="/devis">
                <Button size="lg" className="rounded-full bg-white text-[#1976D2] hover:bg-[#64B5F6] hover:text-white h-14 px-10 text-base font-semibold">
                  Demander un devis <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
            <div aria-hidden className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[#64B5F6]/30 blur-3xl" />
          </div>
        </div>
      </section>
    </div>
  );
}
